// Global audio manager to ensure only one audio plays at a time
class AudioManager {
  private currentAudio: HTMLAudioElement | null = null;

  async play(audio: HTMLAudioElement): Promise<void> {
    // Pause the currently playing audio if there is one
    if (this.currentAudio && this.currentAudio !== audio) {
      this.currentAudio.pause();
    }
    this.currentAudio = audio;
    await audio.play();
  }

  pause(audio: HTMLAudioElement) {
    if (this.currentAudio === audio) {
      audio.pause();
      this.currentAudio = null;
    }
  }

  clear(audio: HTMLAudioElement) {
    if (this.currentAudio === audio) {
      this.currentAudio = null;
    }
  }
}

export const audioManager = new AudioManager();
